import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

/** 更新契約情報 */
export type rnw01p = {
  /** 証券番号 */
  tf_rekeno: string;
  /** ポリシー */
  tf_replcy: string;
  /** 更新回数 */
  tf_reksct: string;
  /** 保険商品コード */
  tf_rehscd: string;
  /** 保険プラン */
  tf_rehkpl: string;
  /** 保険料 */
  tf_regkhk: number;
  /** 内容把握確認 */
  tf_rehaak: string;
  /** 重要事項説明 */
  tf_rejyjk: string;
  /** 意向確認 */
  tf_reikkn: string;
  /** 申込経路 */
  tf_remskr: string;
  /** 申込日 */
  tf_remsdt: string;
  /** 責任開始日 */
  tf_ressdt: string;
  /** 始期日 */
  tf_reskdt: string;
  /** 満期日 */
  tf_remkdt: string;
  /** 異動日 */
  tf_reiddt: string;
  /** 契約者名漢字 */
  tf_rekykj: string;
  /** 契約者名カナ */
  tf_rekykn: string;
  /** 契約者郵便番号 */
  tf_rekyyn: string;
  /** 契約者住所1 */
  tf_rekya1: string;
  /** 契約者住所2 */
  tf_rekya2: string;
  /** 契約者住所3 */
  tf_rekya3: string;
  /** 契約者住所4 */
  tf_rekya4: string;
  /** 契約者電話番号 */
  tf_rekytl: string;
  /** 契約者電話番号（携帯） */
  tf_rekyt2: string;
  /** 契約者メールアドレス */
  tf_rekyma: string;
  /** 他保険有無 */
  tf_rethum: string;
  /** 他保険会社名 */
  tf_rethcm: string;
  /** 他保険保険金額 */
  tf_rethkg: number;
  /** 払込方法 */
  tf_rehkhh: string;
  /** 払込回数 */
  tf_rehkks: string;
  /** 代理店コード */
  tf_redrcd: string;
  /** 支店コード */
  tf_restcd: string;
  /** 募集人コード */
  tf_rebscd: string;
  /** 異動事由 */
  tf_reidjy: string;
  /** 継続意思 */
  tf_rekzis: string;
  /** 変更日時 */
  tf_rehkdt: number;
};

/** 料率情報 */
export type hsm03p = {
  /** 商品コード */
  tf_hrshcd: string;
  /** 商品名称 */
  tf_hrshnm: string;
  /** プラン */
  tf_hrplan: string;
  /** 補償名称 */
  tf_hrplnm: string;
  /** 家財保険料 */
  tf_hrhrhk: number;
  /** 付帯保険料 */
  tf_hrhthk: number;
  /** 合計金額 */
  tf_hrhrgk: number;
  /** 家財保険金額（万円） */
  tf_hrhkkg: number;
  /** 付帯保険金額（万円） */
  tf_hrhtkg: number;
};

/** 更新被保険者情報 */
export type rnw02p = {
  /** 被保険者番号 */
  tf_rhhkno: string;
  /** 所有区分 */
  tf_rhsykb: string;
  /** 用途 */
  tf_rhytkb: string;
  /** 構造 */
  tf_rhkozo: string;
  /** 契約者と同じ */
  tf_rhkysm: string;
  /** 被保険者カナ */
  tf_rhhksk: string;
  /** 被保険者漢字 */
  tf_rhhksj: string;
  /** 被保険者性別 */
  tf_rhhksx: string;
  /** 被保険者生年月日 */
  tf_rhhkbt: string;
  /** 被保険者住所郵便番号 */
  tf_rhhkyn: string;
  /** 被保険者住所1 */
  tf_rhhka1: string;
  /** 被保険者住所2 */
  tf_rhhka2: string;
  /** 被保険者住所3 */
  tf_rhhka3: string;
  /** 被保険者住所4 */
  tf_rhhka4: string;
  /** 被保険者電話番号 */
  tf_rhhktl: string;
  /** 被保険者電話番号（携帯電話） */
  tf_rhhkt2: string;
  /** 被保険者メールアドレス */
  tf_rhhkma: string;
  /** 変更日時 */
  tf_rhhkdt: number;
};

/**
 * 保険料入力オプション用
 */
export type insuranceFeeOptions = {
  /** プラン */
  plan: string;
  /** 表示名 */
  text: string;
};

/**
 * API0660 更新契約情報取得 レスポンスインターフェース
 */
export type renewalResponse = {
  rnw01p?: rnw01p;
  hsm03p?: hsm03p[];
  rnw02p?: rnw02p[];
};

/**
 * API0660 更新契約情報取得
 * @returns
 */
export const getRenewal = async (): Promise<AxiosResponse<renewalResponse>> => {
  return await authRequest.get("/v1/user/renewal");
};
